import React, { useEffect, useMemo, useRef, useState } from "react";
// @ts-ignore
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { useTranslation } from "react-i18next";
import {
  CustomHeaderStyled,
  FromToDatePickerStyled,
} from "./FromToDatePicker.style";
import {
  DATE_PICKER_ADDITIONS_DATES,
  today,
} from "./FromToDatePicker.constants";
import { SearchParams } from "services/urlSetParams";
import useOutsideHandler from "hooks/useOutsideCick";
import { CalendarIcon } from "assets/svgs";

const FromToDatePicker = (props: any) => {
  const {
    setFilter,
    fromDateField = "fromDate",
    toDateField = "toDate",
    isClearable = true,
    defaultDates,
    minusDay,
    isYesterday,
    maxDateToday = true,
  } = props;
  const [setParams, getParams] = SearchParams();
  const [startDate, setStatrDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const outsideOfSelectRef = useRef<any>();
  useOutsideHandler(outsideOfSelectRef, setIsOpen);
  const inputRef = useRef<any>();
  const { t } = useTranslation();

  useEffect(() => {
    if (getParams()[fromDateField] && getParams()[toDateField]) {
      let dateFrom = new Date(getParams()[fromDateField]);
      let dateTo = new Date(getParams()[toDateField]);
      setEndDate(dateTo);
      setStatrDate(dateFrom);
    } else if (defaultDates) {
      const [start, end] = defaultDates;
      setStatrDate(start);
      setEndDate(end);
      const dateStart = new Date(start);
      const dateEnd = new Date(end);
      setFilter((prev: any) => {
        return {
          ...prev,
          [fromDateField]: dateStart.toISOString(),
          [toDateField]: dateEnd.toISOString(),
        };
      });
    }
  }, []);

  const onChange = (dates: any) => {
    const [start, end] = dates;
    setStatrDate(start);
    setEndDate(end);

    if (start && end) {
      let sec: any;
      if (end.getDate() === new Date().getDate() && isYesterday) {
        sec = end.valueOf() + (1000 * 60 * 60 * 24 - 1 - 1000 * 60 * 60 * 24);
      } else {
        sec = end.valueOf() + (1000 * 60 * 60 * 24 - 1);
      }

      let time = new Date(sec);

      const dateStart = new Date(start.toString());
      const dateEnd = new Date(time.toISOString());

      // vaqtni local vaqtga o'zgartirish
      dateStart.toLocaleString("uz-UZ", { timeZone: "Asia/Tashkent" });
      dateEnd.toLocaleString("uz-UZ", { timeZone: "Asia/Tashkent" });

      setFilter((prev: any) => {
        return {
          ...prev,
          [fromDateField]: dateStart.toISOString(),
          [toDateField]: dateEnd.toISOString(),
        };
      });
      setIsOpen(false);
    }
    if (!start && !end) {
      setFilter((prev: any) => {
        return {
          ...prev,
          [fromDateField]: null,
          [toDateField]: null,
        };
      });
    }
  };

  const createAdditionalMenu = () => {
    const popper = document.querySelector(".react-datepicker-popper");

    const additoonalMenu = document.createElement("div");
    additoonalMenu.innerText = "";
    popper?.appendChild(additoonalMenu);
  };

  const additionalMenuItemClick = (newDates: Date[]) => {
    onChange(newDates);
  };

  const renderCustomHeader = () => (
    <CustomHeaderStyled className="custom-header">
      <ul className="list-unstyled m-0 p-0">
        {DATE_PICKER_ADDITIONS_DATES.map((date, index: number) => (
          <li
            key={index}
            onClick={() => {
              additionalMenuItemClick([date.startDate, date.endDate]);
              setIsMenuOpen(false);
            }}
            className="filtered-date-item"
          >
            {t(`general.${date.transKey}`)}
          </li>
        ))}
      </ul>
    </CustomHeaderStyled>
  );

  document.addEventListener("mousedown", (e: any) => {
    if (e.target.className !== "filtered-date-item") {
      setIsMenuOpen(false);
    }
  });

  return (
    <FromToDatePickerStyled className="ms-2">
      <div
        className="date-picer-custom d-flex justify-content-center align-items-center
        range-datepiker"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="calenderIcon"
          onClick={() => {
            setIsOpen(true);
            setIsMenuOpen(true);
            inputRef.current.input.focus();
          }}
        >
          <CalendarIcon />
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <div className="date-picer-start" ref={outsideOfSelectRef}>
            <DatePicker
              dateFormat="dd-MM-yy"
              startDate={startDate}
              endDate={endDate}
              selected={startDate}
              placeholderText={t("general.CHOOSE_FROM_TO_DATE")}
              isClearable={isClearable}
              selectsRange={true}
              onChange={onChange}
              open={isOpen}
              ref={inputRef}
              showPopperArrow={false}
              onCalendarClose={() => setIsOpen(false)}
              // renderCustomHeader={renderCustomHeader}
              onCalendarOpen={() => {
                setIsOpen(true);
                setIsMenuOpen(true);
                createAdditionalMenu();
              }}
              onKeyDown={(e: any) => {
                e.preventDefault();
              }}
              maxDate={maxDateToday ? new Date() : undefined}
            />
          </div>
          {isMenuOpen && renderCustomHeader()}

        </div>
      </div>
    </FromToDatePickerStyled>
  );
};

export default FromToDatePicker;
